export default __webpack_public_path__ + "static/EMPRESARIAL-48035e3c18cc91d7e5df0de87c411907.jpg";